<div
  #menuSurface
  class="core-context-menu"
  role="menu"
  tabindex="-1"
  [class.sm]="size === 'sm'"
  [class.md]="size === 'md'"
  [class.dark]="appearance === 'dark'"
  [class.file-actions]="variant === 'file-actions'"
  [class.position-above]="openDirection === 'above'"
  [attr.aria-label]="ariaLabel"
  (keydown)="onMenuKeydown($event)"
>
  <ng-content select="[contextMenuHeader]"></ng-content>
  <ng-container *ngFor="let item of items; let index = index; trackBy: trackByItemId">
    <div
      *ngIf="item.separatorBefore"
      class="core-context-menu__separator"
      role="separator"
    ></div>

    <button
      #menuItem
      type="button"
      role="menuitem"
      class="core-context-menu__item"
      [class.core-context-menu__item--destructive]="item.destructive"
      [disabled]="item.disabled"
      (click)="onItemClick(item)"
      (keydown)="onKeydown($event, index)"
    >
      <span class="core-context-menu__item-icon" aria-hidden="true">
        <core-ui-icon [name]="item.icon" [size]="item.iconSize || 'sm'" color="currentColor"></core-ui-icon>
      </span>
      <span>{{ item.label }}</span>
    </button>
  </ng-container>
</div>
